import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'airplane-banner',
    templateUrl: './airplane.component.html',
    styleUrls: ['./airplane.component.css'],
    standalone: false
})
export class AirplaneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
